export function getSubject(type) {
	let subject, previewText;

	if (type === 'welcomeEmail' || type === 'confirmEmail') {
		subject = 'Por favor, confirma tu dirección de correo electrónico';
		previewText = '¡Acción requerida! Confirma tu dirección de correo electrónico';
	}
	if (type === 'bookingRequest') {
		subject = 'Tienes una nueva reserva';
		previewText = '¡Grandes noticias! Tienes una nueva reserva';
	}
	if (type === 'bookingRequestQRPayment') {
		subject = 'Tienes una nueva reserva';
		previewText = '¡Grandes noticias! Tienes una nueva reserva';
	}
	if (type === 'bookingRequestGuest') {
		subject = 'Tu solicitud de reserva ha sido enviada a tu anfitrión';
		previewText = '¡Grandes noticias! Tu reserva ha sido compartida con el anfitrión';
	}
	if (type === 'bookingConfirmedQRPaymentToGuest') {
		subject = 'Tu pago para la reserva ha sido confirmada por tu anfitrión';
		previewText = 'Realiza el pago y prepara tu equipaje!';
	}
	if (type === 'bookingConfirmedToHost') {
		subject = 'Has confirmado una reserva';
		previewText = 'Detalles de la reserva confirmada';
	}
	if (type === 'bookingConfirmedToGuest') {
		subject = 'Tu reserva ha sido confirmada por tu anfitrión';
		previewText = 'Prepara tu equipaje, prepárate para tu viaje.';
	}
	if (type === 'bookingDeclinedToGuest') {
		subject = 'Tu solicitud de reserva ha sido rechazada por tu anfitrión';
		previewText = 'Lamentamos informarte que tu solicitud de reserva ha sido rechazada';
	}
	if (type === 'bookingDeclinedQRPaymentToGuest') {
		subject = 'Tu solicitud de reserva ha sido rechazada por tu anfitrión';
		previewText = 'Lamentamos informarte que tu solicitud de reserva ha sido rechazada';
	}
	if (type === 'bookingExpiredGuest') {
		subject = 'Tu solicitud de reserva ha expirado';
		previewText = 'Lamentamos informarte que tu solicitud de reserva ha expirado';
	}
	if (type === 'bookingExpiredHost') {
		subject = '¡Reserva expirada!';
		previewText = 'Lamentamos informarte que tu reserva ha expirado';
	}
	if (type === 'cancelledByHost') {
		subject = 'Tu reserva ha sido cancelada por el anfitrión';
		previewText = 'Lamentamos informarte que tu reserva ha sido cancelada';
	}
	if (type === 'cancelledByGuest') {
		subject = 'Tu reserva ha sido cancelada por el huésped';
		previewText = 'Lamentamos informarte que tu reserva ha sido cancelada';
	}
	if (type === 'completedGuest') {
		subject = 'Por favor, escribe una reseña sobre tu experiencia de estancia';
		previewText = '¡Saludos! Nos encantaría tener una reseña sobre tu experiencia de estancia';
	}
	if (type === 'completedHost') {
		subject = 'Por favor, escribe una reseña sobre tu huésped';
		previewText = '¡Saludos! Nos encantaría tener una reseña sobre tu experiencia de reserva';
	}
	if (type === 'forgotPasswordLink') {
		subject = 'Restablece tu contraseña';
		previewText = '¡Acción requerida! Restablece tu contraseña usando el enlace compartido';
	}
	if (type === 'message') {
		subject = 'Tienes un nuevo mensaje';
		previewText = '¡Alguien te ha enviado un nuevo mensaje!';
	}
	if (type === 'inquiry') {
		subject = 'Tienes una nueva consulta';
		previewText = '¡Alguien te ha enviado una consulta desde el formulario de contacto!';
	}
	if (type === 'documentVerification') {
		subject = 'Estado de verificación de documentos';
		previewText = 'Estado de verificación de documentos';
	}
	if (type === 'contact') {
		subject = 'Tienes una notificación de soporte al cliente';
		previewText = 'Tienes una notificación de soporte al cliente';
	}
	if (type === 'reportUser') {
		subject = 'Tienes una notificación por violación de usuario';
		previewText = 'Has recibido una notificación sobre una violación de usuario';
	}
	if (type === 'bookingPreApproval') {
		subject = 'El anfitrión ha pre-aprobado tu solicitud';
		previewText = '¡Saludos! Tu solicitud de pre-aprobación ha sido aceptada por el anfitrión';
	}
	if (type === 'banStatusServiceStatusBanned') {
		subject = 'Tu cuenta ha sido desactivada';
		previewText = 'Lamentamos informarte que tu cuenta ha sido desactivada';
	}
	if (type === 'banStatusServiceStatusUnBanned') {
		subject = 'Tu cuenta ha sido activada';
		previewText = '¡Saludos! Nos complace informarte que tu cuenta ha sido activada';
	}
	if (type === 'contactSupport') {
		subject = 'Tienes una notificación de soporte al cliente';
		previewText = 'Tienes una notificación de soporte al cliente';
	}
	if (type === 'userFeedback') {
		subject = 'Tienes una notificación de comentarios del cliente';
		previewText = 'Tienes una notificación de comentarios del cliente';
	}
	if (type === 'listPublishRequest') {
		subject = 'Tienes una nueva solicitud de publicación de listado para aprobación';
		previewText = 'Tienes una nueva solicitud de publicación de listado para aprobación';
	}
	if (type == 'adminListApprove') {
		subject = 'Tu solicitud de listado ha sido aprobada';
		previewText = '¡Saludos! Tu solicitud de listado ha sido aprobada';
	}
	if (type == 'adminListReject') {
		subject = 'Tu solicitud de listado ha sido rechazada';
		previewText = 'Lamentamos informarte que tu solicitud de listado ha sido rechazada';
	}

	return {
		subject,
		previewText
	};
}